<template>
  <div>

    <form @submit.prevent="submit">
      <p class="h4 text-blue-facebook mb-2">ACESSE COM:</p>

      <div class="form-group d-flex">
        <!-- <button type="button" class="btn btn-blue-facebook btn-block m-1 btn-social" @click="$emit('social', 'facebook', 'login')"><facebook-icon />Facebook</button> -->
        <button type="button" class="btn btn-blue-facebook btn-block m-1 btn-social" @click="$emit('social', 'linkedin', 'login')"><linkedin-icon />Linkedin</button>
      </div>

      <p class=" mt-4">Ou se você tem uma conta no Bluefit Carreiras ou na 99jobs.com acesse com:</p>

      <div class="form-group">
        <FloatingLabel type="email" input-class="form-control form-control-xl border-color-3" label="E-mail" v-model="username" />
      </div>

      <div class="form-group">
        <FloatingLabel type="password" input-class="form-control form-control-xl border-color-3" label="Senha" v-model="password" />
      </div>

      <div class="form-group d-flex mb-5">
        <div class="custom-control custom-checkbox custom-checkbox-lg custom-checkbox-background">
          <input type="checkbox" class="custom-control-input" id="keep-logged" v-model="keepLogged">
          <label class="custom-control-label" for="keep-logged">Lembrar de mim</label>
        </div>

        <div class="d-flex flex-column ml-auto text-right">
          <a href="#" class="text-color-3 font-weight-bold semi-small" @click.prevent="$emit('changeModal', 'password')"><u>Esqueci minha senha</u></a>
          <a href="#" class="text-color-3 font-weight-bold semi-small mt-1" @click.prevent="$emit('changeModal', 'forgotUser')"><u>Esqueci meu e-mail</u></a>
        </div>
      </div>

      <div class="text-center d-flex flex-column">
        <button type="submit" class="btn btn-color-1" :disabled="!canSubmit">Entrar</button>
        <a href="#" class="btn btn-outline-color-1 rounded mt-2" style="min-height: auto;" @click.prevent="$emit('changeModal', 'preRegister')">Ainda não tenho cadastro</a>
      </div>

      <div class="text-center mt-4">
        <p class="text-muted small m-0">Para acessar nosso Termo De Consentimento, basta <a href="https://99jobs.com/pages/lgpd" target="_blank">clicar aqui</a></p>
      </div>
    </form>

  </div>
</template>

<script>
  import FacebookIcon from "vue-material-design-icons/Facebook.vue"
  import LinkedinIcon from "vue-material-design-icons/Linkedin.vue"
  import FloatingLabel from '@/components/FloatingLabel';

  export default {
    name: 'LoginForm',

    data(){
      return {
        username: '',
        password: '',
        keepLogged: false
      }
    },

    computed: {
      canSubmit(){
        return this.$helpers.isEmail( this.username ) && this.$helpers.validPassword( this.password )
      }
    },

    components: {
      FacebookIcon,
      LinkedinIcon,
      FloatingLabel
    },

    methods: {
      submit(){
        let current_profile = this.$store.state.deviseTrying;
        current_profile.email = this.username;
        current_profile.password = this.password;
        current_profile.keepLogged = this.keepLogged;
        current_profile.provider = null;
        current_profile.id = null;
        this.$store.commit('DEVISE_TRYING', current_profile);

        this.$emit('signIn');
      }

    }
  }
</script>

<style lang="scss" scoped>
</style>